// extracted by mini-css-extract-plugin
export default {"label":"SelectInput_label__3TV-X","select":"SelectInput_select__ks85b","button":"SelectInput_button__yLHTA","selectDisabled":"SelectInput_selectDisabled__wIkTE"};